import {
    useMutation,
    useQuery,
    useQueryClient
} from '@tanstack/react-query';
import {
    add,
    deleteRecord,
    fetch,
    update
} from '../services/CustomersService';
import {Customer} from '../types';

export const useCustomer = (customerId?: string) => {
    const queryClient = useQueryClient();

    // FETCH
    const customerQuery = useQuery({
                                       queryKey: ['customer', customerId],
                                       queryFn: () => fetch(customerId!),
                                       enabled: !!customerId
                                   });

    // CREATE MUTATION
    const createMutation = useMutation({
                                           mutationFn: (values: Customer) => {
                                               const {
                                                   created,
                                                   createdByUsername,
                                                   createdByUser,
                                                   updated,
                                                   updatedByUsername,
                                                   ...rest
                                               } = values;
                                               return add(rest);
                                           },
                                           onSuccess: () => {
                                               queryClient.invalidateQueries({queryKey: ['customers']});
                                               queryClient.invalidateQueries({queryKey: ['all-customers']});
                                           }
                                       });

    // UPDATE MUTATION
    const updateMutation = useMutation({
                                           mutationFn: (values: Customer) => {
                                               if (!customerId) throw new Error('customerId is required parameter');
                                               return update(customerId, values);
                                           },
                                           onSuccess: () => {
                                               queryClient.invalidateQueries({queryKey: ['customers']});
                                               queryClient.invalidateQueries({queryKey: ['all-customers']});
                                               queryClient.invalidateQueries({queryKey: ['customer', customerId]});
                                           }
                                       });

    // DELETE MUTATION
    const deleteMutation = useMutation({
                                           mutationFn: () => {
                                               if (!customerId) throw new Error('customerId is required parameter');
                                               return deleteRecord(customerId);
                                           },
                                           onSuccess: () => {
                                               queryClient.invalidateQueries({queryKey: ['customers']});
                                               queryClient.invalidateQueries({queryKey: ['all-customers']});
                                           }
                                       });

    return {
        record: customerQuery.data,
        loading: customerQuery.isLoading,
        fetchRecord: customerQuery.refetch,
        createRecord: createMutation.mutate,
        updateRecord: updateMutation.mutate,
        deleteRecord: deleteMutation.mutate,
        createMutation,
        updateMutation,
        deleteMutation
    };
};